import { XYZModel } from 'src/app/shared/models/xyz.model';

export class CameraModel {
    eye: XYZModel;
    look: XYZModel;
    up: XYZModel;
}
